import axios from '../utils/axios';

export default function getPremiumJobsList (adminId, params) {
    return axios.get(`/admin/${adminId}/get-premium-jobs-list`, { params });
}